import React, { useState, useEffect, useContext, useMemo } from 'react'
import { Dropdown, Table, TableBody, Loader } from 'semantic-ui-react'
import { UserContext, NotifyContext, PdaContext } from 'context'
import { Card, CardActions, CardBody, CardIcon } from '../../Card'
import Filter from '../../Filter'
import ApplicationActionsModal from './ApplicationsActionsModal'

import Label from '../../Label'
import Paginator from '../../Paginator'

import api from 'actions/api'
import doRequest from 'actions/doRequest'

import { cardsOnPage } from 'constants/config.json'

import './ApplicationsList.css'
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import dateUtils from 'utils/dateUtils'

function ApplicationsList(props) {
    const { intl, tabState, setTabState } = props
    const [loading, setLoading] = useState(false)
    const [applicationsList, setApplicationsList] = useState([])
    const [page, setPage] = useState(1)
    const [pageCount, setPageCount] = useState(1)
    const [sortBy, setSortBy] = useState('byDefault')
    const [sortOptions, setSortOptions] = useState([])
    const [isFilterActive, setIsFilterActive] = useState(false)

    const [options, setOptions] = useState({ cultures: [], warehouses: [], сounterparties: [] })
    const [filter, setFilter] = useState({})

    const { isPda } = useContext(PdaContext)
    const { pushNotify } = useContext(NotifyContext)
    const { currentUser, logout } = useContext(UserContext)

    const translates = useMemo(() => ({
        notFound: intl.formatMessage({ id: 'title.recordNotFound' }),
        byType: intl.formatMessage({ id: 'sort.byType' }),
        filter: intl.formatMessage({ id: 'filter.filter' }),
        elevator: intl.formatMessage({ id: 'title.elevator' }),
        scheduledDate: intl.formatMessage({ id: 'title.scheduledDate' }),
        contrAgentName: intl.formatMessage({ id: 'title.counterparty' }),
        departureType: intl.formatMessage({ id: 'title.departureType' }),
        culture: intl.formatMessage({ id: 'title.culture' }),
        createdDate: intl.formatMessage({ id: 'sort.byCreatedDate' }),
        confirmedDate: intl.formatMessage({ id: 'sort.byConfirmedDate' }),
        weight: intl.formatMessage({ id: 'title.weight' }),
        weightFrom: intl.formatMessage({ id: 'filter.filWeightFrom' }),
        weightTo: intl.formatMessage({ id: 'filter.filWeightTo' }),
        status: intl.formatMessage({ id: 'title.status' }),
        warehouses: intl.formatMessage({ id: 'title.elevator' }),
        byScheduledDate: intl.formatMessage({ id: 'sort.byScheduledDate' }),
        byCounterparty: intl.formatMessage({ id: 'sort.byCounterparty' }),
        byDepartureType: intl.formatMessage({ id: 'sort.byDepartureType' }),
        byCulture: intl.formatMessage({ id: 'sort.byCulture' }),
        byCreatedDate: intl.formatMessage({ id: 'sort.byCreatedDate' }),
        byConfirmedDate: intl.formatMessage({ id: 'sort.byConfirmedDate' }),
        byWeightAsc: intl.formatMessage({ id: 'sort.byWeightAsc' }),
        byWeightDesc: intl.formatMessage({ id: 'sort.byWeightDesc' }),
        byStatus: intl.formatMessage({ id: 'sort.byStatus' }),
        byDefault: intl.formatMessage({ id: 'sort.byDefault' }),
        filterScheduledDate: intl.formatMessage({ id: 'filter.scheduledDate' }),
        filterConfirmedDate: intl.formatMessage({ id: 'filter.confirmedDate' }),
        filterCreatedDate: intl.formatMessage({ id: 'filter.createdDate' }),
        uploading: intl.formatMessage({ id: 'ordertype.uploading' }),
        unloading: intl.formatMessage({ id: 'ordertype.unloading' }),
        calendarTab: intl.formatMessage({ id: 'msg.tabMenu.calendar' })
    }), [intl.locale]) // eslint-disable-line react-hooks/exhaustive-deps

    const setTab = (tab) => {
        setTabState((tabState) => ({ ...tabState, tab }));
    };

    useEffect(() => {
        if (currentUser.role !== 2) { return false }
        setTabState({
            ...tabState,
            menuList: [
                {
                    id: 5,
                    popUpText: translates.calendarTab,
                    iconName: "calendar alternate outline",
                    actions: { onClick: () => setTab(2) },
                },
            ],
        });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const requestTypeOptions = [
        { key: 0, text: translates.unloading, value: 'unloading' },
        { key: 1, text: translates.uploading, value: 'uploading' }
    ]

    const filterList = useMemo(() => {
        return [
            {
                title: translates.contrAgentName,
                type: 'inputText',
                name: 'counterparty',
                options: options.сounterparties,
                isHide: currentUser.role === 3
            },
            {
                title: translates.warehouses,
                type: 'dropdown',
                name: 'warehouse',
                options: options.warehouses
            },
            {
                title: translates.culture,
                type: 'dropdown',
                name: 'culture',
                options: options.cultures
            },
            {
                title: translates.departureType,
                type: 'dropdown',
                name: 'departureType',
                options: requestTypeOptions
            },
            {
                title: translates.filterScheduledDate,
                type: 'date',
                name: 'scheduledDate',
            },
            {
                title: translates.filterCreatedDate,
                type: 'date',
                name: 'createdDate',
            },
            {
                title: translates.filterConfirmedDate,
                type: 'date',
                name: 'confirmedDate',
            },
            {
                title: translates.weightFrom,
                type: 'inputText',
                name: 'weightFrom',
            },
            {
                title: translates.weightTo,
                type: 'inputText',
                name: 'weightTo',
            },
            {
                title: translates.status,
                type: 'dropdown',
                name: 'status',
                options: options.statuses
            },

        ]
    }, [intl.locale, options], options.elevators, options.cars, options.drivers) // eslint-disable-line react-hooks/exhaustive-deps


    const initSortOptions = () => {
        const options = [
            { key: 1, text: translates.byCreatedDate, value: "byCreatedDate" },
            { key: 2, text: translates.byScheduledDate, value: "byScheduledDate" },
            { key: 3, text: translates.byConfirmedDate, value: "byConfirmedDate" },
            { key: 5, text: translates.byDepartureType, value: "byDepartureType" },
            { key: 6, text: translates.byCulture, value: "byCulture" },
            { key: 7, text: translates.byWeightAsc, value: "byWeightAsc" },
            { key: 8, text: translates.byWeightDesc, value: "byWeightDesc" },
            { key: 9, text: translates.byStatus, value: "byStatus" },
            { key: 100, text: translates.byDefault, value: "byDefault" },
        ]
        if (currentUser.role !== 3) {
            options.push({ key: 4, text: translates.byCounterparty, value: "byCounterparty" })
        }
        setSortOptions(options);
    }

    const loadApplications = (page = 1) => {
        setApplicationsList([])
        setLoading(true)

        const offset = cardsOnPage * (page - 1), count = cardsOnPage

        return doRequest(api.applications.list(
            offset, count, sortBy, filter.culture, filter.warehouse, filter.counterparty, filter.departureType,
            filter.scheduledDate, filter.createdDate, filter.confirmedDate, filter.weightFrom, filter.weightTo, filter.status), pushNotify, logout)
            .ready.then(data => {
                const { applications, count } = data
                const pages = Math.ceil(count / cardsOnPage)

                setApplicationsList(applications)

                if (page > pages && pages > 0) {
                    loadApplications(pages)
                } else {
                    setPageCount(pages)
                    setPage(page)
                }
            }).catch(e => {
                setApplicationsList([])
            }).finally(() => {
                setLoading(false)
            })
    }

    const getOptions = () => {
        let requests = []
        requests.push({ statuses: [{ id: 1, name: 2 }] })
        requests.push(doRequest(api.applicationsStatuses.list(), pushNotify, logout).ready)
        requests.push(doRequest(api.elevators.list(), pushNotify, logout).ready)
        requests.push(doRequest(api.cultures.list(), pushNotify, logout).ready)

        return Promise.all(requests).then(result => {
            const res = result.reduce((acc, data) => {
                if (data.elevators) return { ...acc, warehouses: data.elevators.map((elevator) => { return { key: elevator.id, value: elevator.id, text: elevator.name } }) };
                if (data.cultures) return { ...acc, cultures: data.cultures.map((culture) => { return { key: culture.id, value: culture.id, text: intl.formatMessage({ id: `cultures.${culture.title}` }) } }) };
                if (data.statuses) return {
                    ...acc, statuses: data.statuses.map((status) => {
                        return { key: status.id, value: status.id, text: intl.formatMessage({ id: `title.application.status.${status.title}` }) }
                    })
                };
                return acc
            }, {})
            setOptions({ ...res })
        }).catch(console.error)
    }

    useEffect(() => {
        const fetchData = async () => {
            await getOptions();
            await loadApplications(1)
        }
        fetchData();
        initSortOptions();
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const checkIsFilterActive = () => {
        let isFilterActive = false;
        for (const key in filter) {
            const el = filter[key];
            if (el !== "" && el !== null && el !== undefined) {
                if (Array.isArray(el) && el.length > 0) {
                    isFilterActive = true;
                    break;
                } else if (filter[key] instanceof Date) {
                    isFilterActive = true;
                    break;
                } else if (typeof filter[key] === "string") {
                    isFilterActive = true;
                    break;
                }
            }
        }
        setIsFilterActive(isFilterActive);
    };

    useEffect(() => {
        if (loading) return
        loadApplications(page)
        checkIsFilterActive();
    }, [sortBy, filter]) // eslint-disable-line react-hooks/exhaustive-deps

    const onConfirmEditModal = async (data) => {
        try {
            if (!data.scheduledDate) {
                pushNotify('error', 'title.error', 'msg.dateMustBeFilled', 2000)
                return
            }

            if (!data.weight) {
                pushNotify('error', 'title.error', 'msg.weightMustBeFilled', 2000)
                return
            }

            if (data?.weight < 1 || isNaN(data?.weight)) {
                pushNotify('error', 'title.error', 'msg.weightMustBeGreaterThanZero', 2000)
                return
            }

            const response = await doRequest(api.suggestedEdits.add(data), pushNotify, logout).ready;
            if (response?.text === 'success') {
                pushNotify('success', 'title.success', 'msg.sendRequstSuccess', 2000);
            }
            await loadApplications(page);
        } catch (error) { console.log(error); }
    }

    return (
        <React.Fragment>

            <div className="topPanel">
                <Filter filter={filter} disabled={loading} setFilter={e => { setFilter(e) }} filterList={filterList} isFilterActive={isFilterActive} className="modalMaxWidth" />
                <Dropdown options={sortOptions} selection icon="sort" value={sortBy} onChange={(e, { value }) => setSortBy(value)} />
            </div>
            {loading ?
                <Loader className={"residue-loader"} active inline="centered" />
                :
                applicationsList.length === 0 ?
                    <Label text={translates.notFound} />
                    :
                    isPda ?
                        applicationsList.map((application) => (
                            <Card key={application.id} className="departureCard">
                                <CardIcon name="truck" />
                                <CardBody>
                                    <span><b>{translates.elevator}:</b> {application.elevator}</span>
                                    <span><b>{translates.scheduledDate}:</b> {dateUtils.getDateFromString(application.scheduledDate)}</span>
                                    {currentUser.role !== 3 && <span><b>{translates.contrAgentName}:</b> {application.contrAgentName}</span>}
                                    <span><b>{translates.departureType}:</b> {translates[application.departureType]}</span>
                                    <span><b>{translates.culture}:</b> {intl.formatMessage({ id: `cultures.${application.nomenclature}` })}</span>
                                    <span><b>{translates.weight}:</b> {application.weight}</span>
                                    <span><b>{translates.status}:</b> {intl.formatMessage({ id: `title.application.status.${application.status}` })}</span>
                                    <CardActions>
                                        <ApplicationActionsModal application={application} onConfirmEditModal={onConfirmEditModal} options={options} reloadApp={loadApplications} />
                                    </CardActions>
                                </CardBody>
                            </Card>
                        ))
                        :
                        <Table celled striped>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>{translates.elevator}</Table.HeaderCell>
                                    <Table.HeaderCell>{translates.scheduledDate}</Table.HeaderCell>
                                    {currentUser.role !== 3 && <Table.HeaderCell>{translates.contrAgentName}</Table.HeaderCell>}
                                    <Table.HeaderCell>{translates.departureType}</Table.HeaderCell>
                                    <Table.HeaderCell>{translates.culture}</Table.HeaderCell>
                                    <Table.HeaderCell>{translates.weight}</Table.HeaderCell>
                                    <Table.HeaderCell>{translates.status}</Table.HeaderCell>
                                    <Table.HeaderCell></Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <TableBody>
                                {
                                    applicationsList.map((application) => (
                                        <Table.Row key={application.id} className={application.crash ? 'red' : ''}>
                                            <Table.Cell>{application.elevator}</Table.Cell>
                                            <Table.Cell>{dateUtils.getDateFromString(application.scheduledDate)}</Table.Cell>
                                            {currentUser.role !== 3 && <Table.Cell>{application.contrAgentName}</Table.Cell>}
                                            <Table.Cell>{translates[application.departureType]}</Table.Cell>
                                            <Table.Cell>{intl.formatMessage({ id: `cultures.${application.nomenclature}` })}</Table.Cell>
                                            <Table.Cell>{application.weight}</Table.Cell>
                                            <Table.Cell>{intl.formatMessage({ id: `title.application.status.${application.status}` })}</Table.Cell>
                                            <Table.Cell className="actionColumn"><ApplicationActionsModal application={application} onConfirmEditModal={onConfirmEditModal} options={options} reloadApp={loadApplications} /></Table.Cell>
                                        </Table.Row>
                                    ))
                                }
                            </TableBody>
                        </Table>
            }
            <Paginator pageCount={pageCount} page={page} setPage={loadApplications} disabled={loading} />
        </React.Fragment>
    )
}

export default ApplicationsList;
